import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { ContentModel, PIMAttributesApiResultModel } from "@tecumseh/Services/PIMGetAttributes";
import { Draft } from "immer";


const initialState: PIMAttributesApiResultModel = {
    PIMAttributesList: [],
    loading: false
};

const reducer = {
    "Custom/PIMAttributes/StartSettingContents": (draft: Draft<PIMAttributesApiResultModel>, action: { attributeResults: any }) => {
        draft.loading = true;
    },
    "Custom/PIMAttributes/SetContents": (draft: Draft<PIMAttributesApiResultModel>, action: { attributeResults: any }) => {
        draft.PIMAttributesList = JSON.parse(action.attributeResults);
        draft.loading = false;
    },
    
};
export default createTypedReducerWithImmer(initialState, reducer);
